/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import {
    IALBServicesStatus,
    ICluster,
    IGslb,
    IPortalConfiguration,
    ISystemConfiguration,
} from 'generated-types';

export interface ISystemInfoError {
    data: string,
}

export interface IUiDefinedPortalConfiguration extends IPortalConfiguration {
    port?: number;
}

export interface IUiDefinedSystemConfiguration extends ISystemConfiguration {
    portal_configuration?: IUiDefinedPortalConfiguration;
}

export interface ISystemInfo {
    systemconfiguration?: IUiDefinedSystemConfiguration;
    albservices?: IALBServicesStatus;
    cluster?: ICluster;
    gslb?: IGslb;
}

export interface ISystemInfoState extends ISystemInfo {
    loading: boolean;
    loaded: boolean;
    loadingError: ISystemInfoError | null;
    // Flag indicating if re-loading data is allowed to avoid unnecessary loading calls, given that
    // System Info data can be valid through a period of time after its last loading
    allowReload: boolean;
}

export const initialSystemInfoState: ISystemInfoState = {
    loading: false,
    loaded: false,
    loadingError: null,
    allowReload: true,
};
